import { HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { Router } from '@angular/router';
import { catchError, throwError } from 'rxjs';

export const authInterceptor: HttpInterceptorFn = (req, next) => {
  const token = localStorage.getItem('token');
  const router = inject(Router);
  
  if (token) {
    const cloned = req.clone({
      headers: req.headers.set('Authorization', `Bearer ${token}`)
    });
    
    return next(cloned).pipe(
      catchError((error) => {
        // Handle 401 (Unauthorized) and 403 (Forbidden) - both mean invalid/expired token
        if (error.status === 401 || error.status === 403) {
          // Clear local storage
          localStorage.removeItem('token');
          localStorage.removeItem('user');
          
          // Redirect to login
          router.navigate(['/login']);
        }
        
        return throwError(() => error);
      })
    );
  }
  
  return next(req);
};
